import React from 'react'
import { initializeApollo } from '@gql/client'
import { PaginaDocument } from '@gql/graphql'
import { NextWrapper } from 'data-fetching-wrapper'
import CartTemplate from '@components/templates/CartTemplate/CartTemplate'

const CartPage = ({ pagina, cartContent }) => {
  return <CartTemplate pagina={pagina} cartContent={cartContent} />
}

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ preview, previewData, locale }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'cart', preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    const cartContent = pagina?.pagebuilders?.find((x) => x.key === 'cartContent') ?? null

    return {
      props: { pagina, cartContent },
      revalidate: 60 * 10,
    }
  },
  'cart'
)

export default CartPage
